export class FnTimeDuration {
  time: number;
  errorMessage: string;
  constructor(time: number, errorMessage: string) {
    this.time = time;
    this.errorMessage = errorMessage;
  }
}
